export function GridSvg() {
  return (
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 [z-index:30] size-full fill-primary/50 stroke-primary/50 [mask-image:linear-gradient(to_bottom,_#ffffffad,_#ffffffad)] opacity-[.25]"
    >
      <defs>
        <pattern
          id=":Sf:"
          width="14"
          height="14"
          patternUnits="userSpaceOnUse"
          x="-1"
          y="-1"
        >
          <path d="M.5 14V.5H14" fill="none" strokeDasharray="0"></path>
        </pattern>
      </defs>
      <rect width="100%" height="100%" strokeWidth="0" fill="url(#:Sf:)"></rect>
    </svg>
  );
}
